import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,

    '& .titleContainer': {
      maxWidth: 'none',
      alignSelf: 'center',

      '& > div': {
        justifyContent: 'center',
      },
    },
  },
  content: {
    padding: theme.spacing(2),
  },
  logoHeader: {
    display: 'flex',
    height: 150,
    '& .IMAGE': {
      maxWidth: 250,
      margin: 'auto',
    },
  },
  performLogo: {
    margin: '0 auto',
    width: 150,
  },
}));

export default useStyles;
